module.exports = __webpack_public_path__ + "static/media/PetInTimeFrame1.dfcbca5f.png";